import React, { useEffect, useState } from "react";
import MainPart from "../post/MainPartPosr";
import GroupsFeeds from "../post/Grouppost";
import { useIds } from "../../hook/AdminContext";
import { useLocation } from "react-router-dom";
import { show_proper_words } from "../../utils/Constant";
import RecordNotFound2 from "../../components/recordNotFound/SataNitFound";
import PageLoading from "../../components/loader/PageLoading";
import FeedSkeletonLoader from "../../components/loader/Feedskeltonloader";
import { Tab, Tabs } from "@mui/material";

export default function Home() {
  const { userInfo } = useIds();
  const [showInfoBox, setShowInfoBox] = useState(false);
  const [previewLink, setPreviewLink] = useState(true);
  const [urlLink, setUrlLink] = useState("");
  const { setBreadCrumb, jobloader } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("jobs");
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (firstSegment !== "home") {
      setBreadCrumb([
        {
          name: `${show_proper_words(firstSegment)}`,
          path: "",
          active: true,
        },
      ]);
    } else {
      setBreadCrumb([]);
    }
  }, [firstSegment]);

  if (
    (userInfo?.type === 2 || userInfo?.type === 1) &&
    Array.isArray(userInfo?.source) &&
    userInfo?.source.length === 0
  ) {
    return (
      <div className="col-12 text-center">
        <RecordNotFound2 title="You have no access to any source" />
      </div>
    );
  }

  return (
    <>
      {isMobile ? (
        <>
          <div className="d-flex justify-content-around my-2">
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Feeds" value="feeds" />
              <Tab label="Jobs" value="jobs" />
            </Tabs>
          </div>

          <div className="container" style={{ maxWidth: "100%" }}>
            {selectedTab === "feeds" ? (
              <MainPart
                showInfoBox={showInfoBox}
                setShowInfoBox={setShowInfoBox}
                userInfo={userInfo}
                previewLink={previewLink}
                setPreviewLink={setPreviewLink}
              />
            ) : (
              <GroupsFeeds loading={loading} setLoading={setLoading} />
            )}
          </div>
        </>
      ) : (
        <div className="d-flex">
          <div className="container" style={{ maxWidth: "992px" }}>
            {loading ? (
              <FeedSkeletonLoader />
            ) : (
              <div className="groupsFeeds">
                <MainPart
                  showInfoBox={showInfoBox}
                  setShowInfoBox={setShowInfoBox}
                  userInfo={userInfo}
                  previewLink={previewLink}
                  setPreviewLink={setPreviewLink}
                  urlLink={urlLink}
                  setUrlLink={setUrlLink}
                />
              </div>
            )}
          </div>
          <div>
            <GroupsFeeds loading={loading} setLoading={setLoading} />
          </div>
        </div>
      )}
    </>
  );
}
